export default __webpack_public_path__ + "static/media/bg4.4b26d2ee.png";